import React, { Fragment, useState } from "react";
import { connect } from "react-redux";
import OpenInBuilderModal from "components/OpenInBuilder/OpenInBuilderModal";
import { selectFlow, selectFlows } from "reducers/account/flows";
import { buildDeepLinkToStepChild } from "utils/steps";
import { openFlowInBuilder } from "utils/url";
import { canOpenInBuilder } from "utils/chromeExtension";
import * as persistence from "helpers/persistence";
import { selectChromeExtensionVersion } from "reducers/chromeExtension";
import { navigate } from "actions/routing";

const OpenInBuilderButton = ({
  openNewTab,
  stepGroupId,
  stepChildId,
  render,
  url,
  chromeExtensionVersion
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dontShowOpenInBuilderModal =
    persistence.getItem("dontShowOpenInBuilderModal") === "true";

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleOpen = () => {
    if (dontShowOpenInBuilderModal) {
      openFlowInBuilder(stepGroupId, stepChildId, url);
    } else {
      setIsOpen(true);
    }
  };

  const editStepInChrome = () => {
    const editStepInChromeUrl = stepChildId
      ? `/edit-in-chrome/stepGroup/${stepGroupId}/stepChild/${stepChildId}`
      : `/edit-in-chrome/stepGroup/${stepGroupId}`;
    openNewTab(editStepInChromeUrl, true);
  };

  const isLatestVersion = canOpenInBuilder(chromeExtensionVersion);

  return (
    <Fragment>
      {isOpen && (
        <OpenInBuilderModal
          stepGroupId={stepGroupId}
          stepChildId={stepChildId}
          url={url}
          onClose={handleClose}
        />
      )}
      {render(isLatestVersion ? handleOpen : editStepInChrome)}
    </Fragment>
  );
};

function mapStateToProps(state, { stepGroupId, stepChildId }) {
  const stepGroup = selectFlow(state, stepGroupId) || {};
  const allSteps = selectFlows(state);
  const url = buildDeepLinkToStepChild(stepGroup, stepChildId, allSteps);

  return {
    url,
    chromeExtensionVersion: selectChromeExtensionVersion(state)
  };
}

export default connect(mapStateToProps, { openNewTab: navigate })(
  OpenInBuilderButton
);
